// Backend content is displayed unchanged.
// Known interface messages use the existing local language dictionary.

function toText(value) {
  return value == null ? '' : String(value)
}

export function translatePublicText(value) {
  const original = toText(value)
  let message = original

  if (
    this &&
    typeof this.$te === 'function' &&
    typeof this.$t === 'function' &&
    this.$te(original)
  ) {
    const translated = this.$t(original)
    if (typeof translated === 'string') {
      message = translated
    }
  }

  // Preserve existing callers that use .then(...).
  return Promise.resolve(message)
}

function displayOriginal(el, binding) {
  const original = toText(binding.value)
  if (el.textContent !== original) {
    el.textContent = original
  }
}

export default {
  install(Vue) {
    Vue.prototype.$translatePublic = translatePublicText

    Vue.directive('public-i18n', {
      bind: displayOriginal,
      componentUpdated: displayOriginal
    })

    // Existing Vant components already receive the raw value via :title.
    Vue.directive('public-i18n-title', {})
  }
}